import { useState } from 'react';
import { ShieldAlert, ChevronDown, ChevronUp, Crosshair } from 'lucide-react';
import { kksPoints, kksOk, mv, KKS_LIMIT } from '../lib/inspect';

// slim red banner on the start screen: KKS points above the protection limit (Eoff > −850 mV)
export default function KksBanner({ t, project, onOpen }) {
  const [open, setOpen] = useState(false);
  const bad = kksPoints(project).filter((f) => kksOk(f.kks) === false);
  if (!bad.length) return null;
  return (
    <div className="kks-banner" data-testid="kks-alarm-banner">
      <button className="kks-banner-head" data-testid="kks-alarm-toggle" onClick={() => setOpen(!open)}>
        <ShieldAlert size={16} />
        <b data-testid="kks-alarm-text">{t.kaTitle.replace('{n}', bad.length)}</b>
        <small>Eoff &gt; {KKS_LIMIT} mV</small>
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>
      {open && (
        <ul className="kks-banner-list" data-testid="kks-alarm-list">
          {bad.map((f, i) => (
            <li key={f.id} data-testid={`kks-alarm-item-${i}`}>
              <span><b>{f.name || t.fit_kks}</b><small>Eoff {mv(f.kks.eoff)} mV{f.kks.t ? ` · ${new Date(f.kks.t).toLocaleDateString(t.locale)}` : ''}</small></span>
              <button className="btn btn-outline btn-sm" data-testid={`kks-alarm-open-${i}`} onClick={() => onOpen(f)}><Crosshair size={14} /> {t.kaOpen}</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
